export { store as iconStore } from './icons';
